import { render, staticRenderFns } from "./VehicleValuationView.vue?vue&type=template&id=1931db10&scoped=true&"
import script from "./VehicleValuationView.vue?vue&type=script&lang=js&"
export * from "./VehicleValuationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1931db10",
  null
  
)

export default component.exports